module.exports = __webpack_public_path__ + "site-build/img/item.a8726b2c.jpg";